module.exports = __webpack_public_path__ + "static/img/news_4.9b1c85a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/news_4.jpg
// module id = peKu
// module chunks = 0